export const KwhLinks = [
  {
    name: 'kwh.actions.archiving.title',
    param: { modal: 'openArchivingModal' },
  },
  {
    name: 'kwh.actions.mahnversand.title',
    param: { modal: 'openDeadlinesModal' },
  },
  {
    name: 'kwh.actions.letterTemplate.title',
    param: { modal: 'openLetterTemplateModal' },
  },
  {
    name: 'kwh.actions.letterHead.title',
    param: { modal: 'openLetterUploadModal' },
  },
  {
    name: 'kwh.actions.admins.title',
    param: { modal: 'openKWHUserAdministration' },
  },
  {
    name: 'kwh.actions.fomEmail.title',
    param: { modal: 'openFomEmailModal' },
  },
];

export const KwsLinks = [
  {
    name: 'kws.actions.privacy.title',
    param: { modal: 'openLegalModal' },
  },
  {
    name: 'kws.actions.bankinfo.title',
    param: { modal: 'openImprintModal' },
  },
  {
    name: 'kws.actions.nachhaltigkeit.title',
    param: { modal: 'openSustainabilityModa' },
  },
];

export const OverviewLinks = [
  {
    name: 'overview.actions.logo.title',
    param: { modal: 'openLogoModal' },
  },
  {
    name: 'overview.actions.adminUsers.title',
  },
];
